import { COOKIE_KEY_MAP, cookie } from '@shared/services';
import {
    TRACK_EVENT,
    GA_TRACK_EVENT_NAME_MAP,
    FB_PIXEL_TRACK_EVENT_NAME_MAP,
} from './constants';

type EventData = {
    event: TRACK_EVENT;
};

class TrackingObserver {
    private static instance: TrackingObserver;

    private googleAnalyticsId: string | null;

    private facebookPixelId: string | null;

    private googleSearchConsoleContent: string | null;

    private constructor() {
        this.googleAnalyticsId = null;

        this.facebookPixelId = null;

        this.googleSearchConsoleContent = null;
    }

    public static getInstance(): TrackingObserver {
        if (!TrackingObserver.instance) {
            TrackingObserver.instance = new TrackingObserver();
        }

        return TrackingObserver.instance;
    }

    public setGoogleAnalyticsId(googleAnalyticsId: string) {
        this.googleAnalyticsId = googleAnalyticsId;
    }

    public setFacebookPixelId(facebookPixelId: string) {
        this.facebookPixelId = facebookPixelId;
    }

    public setGoogleSearchConsoleContent(googleSearchConsoleContent: string) {
        this.googleSearchConsoleContent = googleSearchConsoleContent;
    }

    public getGoogleAnalyticsId() {
        return this.googleAnalyticsId;
    }

    public getFacebookPixelId() {
        return this.facebookPixelId;
    }

    public getGoogleSearchConsoleContent() {
        return this.googleSearchConsoleContent;
    }

    static getUid() {
        return cookie.get(COOKIE_KEY_MAP.memberUid) || cookie.get(COOKIE_KEY_MAP.beacon);
    }

    static getPagePath() {
        return window.location.pathname;
    }

    public logEvent(eventName: TRACK_EVENT, eventData: EventData) {
        if (typeof window === 'undefined') {
            return;
        }

        const _eventData = {
            ...eventData,
            uid: TrackingObserver.getUid(),
            page_path: TrackingObserver.getPagePath(),
        };

        if (
            Object.prototype.hasOwnProperty.call(window, 'gtag') &&
            window.gtag &&
            this.getGoogleAnalyticsId()
        ) {
            const gaEventName = GA_TRACK_EVENT_NAME_MAP[eventName];

            if (gaEventName) {
                window.gtag('event', gaEventName, _eventData);
            }
        }

        if (
            Object.prototype.hasOwnProperty.call(window, 'fbq') &&
            window.fbq &&
            this.getFacebookPixelId()
        ) {
            const fbEventName = FB_PIXEL_TRACK_EVENT_NAME_MAP[eventName];

            if (fbEventName) {
                window.fbq('trackCustom', fbEventName, _eventData);
            }
        }
    }
}

const instance = TrackingObserver.getInstance();

const logEvent = TrackingObserver.getInstance().logEvent.bind(instance);

export { instance, logEvent };
